import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../../autenticacion/servicios/auth.service';
import {ConsumerService} from '../../../recursos/servicio/consumer.service';
import {WebServices} from '../../../recursos/modelo/consumerModel/web-services.enum';
import {UtilConfig} from '../../../../autenticacion/servicios/UtilConfig';
import {Router} from '@angular/router';
import * as moment from 'moment';
import {BillingConfiguration} from '../../seguridad/emisor/recursos/modelo/emisor-configuration';
import {TipoDocumento} from '../../seguridad/emisor/recursos/modelo/tipo-documento.enum';
import {Observable} from '../../../../../../node_modules/rxjs/Observable';
import {map, startWith} from '../../../../../../node_modules/rxjs/operators';
import {TipoNota} from '../recursos/tipoNota.enum';
import {MatSnackBar} from '@angular/material';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';

declare var $: any;
declare var swal: any;

@Component({
    selector: 'app-nota-credito',
    templateUrl: './view/nota-credito.component.html',
    styleUrls: ['./css/nota-credito.component.scss'],
    providers: [AuthService, ConsumerService]
})
export class NotaCreditoComponent implements OnInit {

    @Input() documento;
    IGV = 18.0;
    loading = false;
    overload_descripcion = false;
    overload_item = false;
    loadingConsultas = [
        {
            modulo: 'Cargando Series',
            cargando: true
        },
        {
            modulo: 'Cargando detalle documento',
            cargando: true
        }
    ];
    mensaje = '';
    error = false;
    formNotaCredito: FormGroup;
    vld_serie: FormControl;
    vld_motivo: FormControl;
    formNotaCredito_type_07: FormGroup;
    vld_cantidad: FormControl;
    vld_monto: FormControl;
    disabledGuardarModificacionItem = false;
    serie: String;
    tipo: any;
    motivo: String;
    nota: any;
    tipos = [
        {value: '01', label: TipoNota.ANULACION},
        {value: '03', label: TipoNota.MODIFICACION_DESCRIPCION},
        {value: '04', label: TipoNota.DESCUENTO_GLOBAL},
        {value: '06', label: TipoNota.DEVOLUCION_TOTAL},
        {value: '07', label: TipoNota.DEVOLUCION_ITEM},
    ];
    tipoDoc = '07';
    usuarioSession: any;
    options: String[] = [];
    filteredOptions: Observable<String[]>;
    myControl = new FormControl();
    settings: any;

    nroCuotas = 1;
    montoPendiente: number = null;
    cuotaSelected: number = null;
    data: any[] = [];
    dataPreview: any[] = [];
    changeAmountPay: string;
    bsConfigCuota: Partial<BsDatepickerConfig>;
    colorTheme = 'theme-dark-blue';
    payment: any = {
        cuo: []
    };
    changeDate: any;
    minDate: any;
    maxDate: any;
    datosItemSelected: any = {
        invoicedQuantity: ''
    };
    formChangeAmountOrDate: FormGroup;
    vld_changeMonto: FormControl;
    vld_changeDate: FormControl;
    datosBk: any;
    datoBk: any;
    preview = false;
    receiver: any;
    codCurrency: any;
    monto: number;

    constructor(private util: UtilConfig,
                private fb: FormBuilder,
                private router: Router,
                private snackBar: MatSnackBar,
                private consumerService: ConsumerService) {
        this.tipo = this.tipos[0];
        this.usuarioSession = this.util.getCurrentUser();
        this.IGV = this.usuarioSession.customer.igv || 18.0;
        this.createFormControls();
        this.createFormNotaCredito();
        this.bsConfigCuota = Object.assign({}, {
            containerClass: this.colorTheme,
            showWeekNumbers: false,
            dateInputFormat: 'YYYY-MM-DD'
        });
        this.vld_changeDate = new FormControl({}, [Validators.required]);
        this.vld_changeMonto = new FormControl({}, [Validators.required]);
        this.changeAmountOrDate();
    }

    changeAmountOrDate() {
        this.formChangeAmountOrDate = this.fb.group({
            'monto': this.vld_changeMonto,
            'fecha': this.vld_changeDate
        });
    }


    ngOnInit(): void {
        this.monto = 0.0;
        this.getSeries();
        this.filteredOptions = this.myControl.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );

        this.getDetalleFactura();

    }


    createFormControls() {
        this.vld_serie = new FormControl({value: ''}, [Validators.required]);

        this.vld_motivo = new FormControl({value: ''}, [Validators.nullValidator]);

        this.vld_cantidad = new FormControl({value: ''}, [Validators.required]);

        this.vld_monto = new FormControl({value: ''}, [Validators.required]);
    }

    createFormNotaCredito() {
        this.formNotaCredito = this.fb.group({
            'serie': this.vld_serie,
            'motivo': this.vld_motivo,
            'monto': this.vld_monto
        });

        this.formNotaCredito_type_07 = this.fb.group({
            'cantidad': this.vld_cantidad
        });


    }

    onSubmitNotaCredito() {
        this.error = false;
        this.mensaje = '';

        if (this.tipo.value != '13' && this.tipo.value != '04' && (this.motivo == '' || this.motivo == undefined)) {
            swal(
                'Campos obligatorios',
                'Debe completar todo los campos con (*)',
                'error'
            );
            return;
        }

        if (this.formNotaCredito.valid) {
            this.generarDocumentoNotaCredito();
        } else {
            swal(
                'Campos obligatorios',
                'Debe completar todo los campos con (*)',
                'error'
            );
        }
    }

    generarDocumentoNotaCredito() {

        const peticion: any = {
            id: this.documento.id, // id Boleta o Factura
            documentType: this.tipoDoc, // Documento que se va a crear Nota Credito "07" sino Nota Debito "08"
            reason: this.motivo, // Motivo
            typeCreditNote: this.tipo.value,
            percent: this.IGV,
            codCPE: this.documento.fileName.split('-')[1], // codCPE factura, boleta
            numSerieCPE: this.documento.fileName.split('-')[2], // Serie factura, boleta
            montoPendientePago: this.montoPendiente,
            numCPE: this.documento.fileName.split('-')[3], // correlativo factura, boleta
            serieNota: this.serie, // serie de la nota credito
            customer: {
                ruc: this.documento.fileName.split('-')[0]
            }
        };
        const items = [];
        const itemSeleccionados = [];
        if (this.tipo.value == '03' || this.tipo.value == '07') {
            $.each(this.data, function (pos, item) {
                if (item.selected) {
                    const linea = {
                        lineNumber: item.lineNumber,
                        description: item.description,
                        lineExtensionAmount: item.lineExtensionAmount,
                        invoicedQuantity: item.invoicedQuantity
                    };
                    itemSeleccionados.push(linea);
                }
            });

            if (itemSeleccionados.length > 0)
                peticion.listaItems = itemSeleccionados;

            if (itemSeleccionados.length == 0) {
                swal(
                    'Campos obligatorios',
                    'Debe seleccionar al menos 1 items del documento',
                    'error'
                );
                return false;
            }
        }

        if (this.tipo.value == '13') {
            const paymentTerms = [];
            paymentTerms.push({
                idCuota: 'Credito',
                montoPago: this.montoPendiente
            });
            this.payment.cuo.forEach(item => {
                paymentTerms.push({
                    idCuota: item.idCuota,
                    montoPago: item.montoPago,
                    fechaPago: item.fechaPago
                });
            });
            peticion.paymentTerms = paymentTerms;
        }

        if (this.tipo.value == '04') {
            const linea = {
                lineNumber: 1,
                description: this.motivo === ''? 'DESCUENTO GLOBAL' : this.motivo,
                lineExtensionAmount: this.monto * (this.IGV / 100 + 1),
                unitPrice: this.monto,
                invoicedQuantity: 1
            };
            itemSeleccionados.push(linea);
            peticion.listaItems = itemSeleccionados;
        }
        const body = JSON.stringify(peticion);

        this.loading = true;
        this.consumerService.create(WebServices.URL_GENERAR_DOCUMENTOS, body)
            .subscribe(result => {
                console.log(result);
                this.loading = false;
                if (result.codigo != 1) {
                    swal(
                        'No se pudo crear la nota de credito',
                        result.mensaje,
                        'error'
                    );
                } else {
                    swal({
                        title: 'Nota de credito creada',
                        text: 'Fue creada exitosamente la nota de credito. Refrescando lista.',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 3000
                    });

                    setTimeout(() => {
                        const filtroList: any = {};
                        let rangeDates: Date[];
                        // RANGO FECHA
                        rangeDates = [new Date(), new Date()];
                        filtroList.tipoFecha = 'SUBIDA';
                        filtroList.inicio = moment(rangeDates[0]).format('MM/DD/YYYY');
                        filtroList.fin = moment(rangeDates[1]).format('MM/DD/YYYY');
                        filtroList.documentType = 'CREDIT_NOTE';
                        filtroList.estadoRegistro = 'TODAS';
                        filtroList.search = '1';
                        $('ul#slide-out').removeClass('open');
                        $('i.cerrarAleta').removeClass('open');
                        $('.closePopupNotaDebito').click();
                        this.router.navigate(['/content', {outlets: {'second': ['logEmisorV2', filtroList]}}]);
                    }, 2000);
                }


            }, err => {
                this.loading = false;
                this.util.abrirModalErrorParaServicios(err, 'No se pudo crear el documento', this.router);
            });

    }

    getSeries() {
        const body = JSON.stringify({
            customer: {
                id: this.util.getCurrentUser().customer.id,
                ruc: this.util.getCurrentUser().customer.ruc
            }
        });

        this.loadingConsultas[0].cargando = true;
        this.consumerService.post(WebServices.URL_GET_SERIES, body).subscribe(x => {
            let emisorConfig: BillingConfiguration[] = x['billingConfigurationsList'];
            emisorConfig = emisorConfig.filter(x => x.documentType === TipoDocumento.CREDIT_NOTE);
            emisorConfig = emisorConfig.filter(x => {
                let seAgrega = false;
                // if (this.tipo != TipoNota.ANULACION) {
                if (this.documento.documentType == 'TICKET') {
                    if (/^([B][A-Z0-9]{3}|EB01|[0-9]{1,4}|-)$/.test(x.serialNumber.toString())) {
                        seAgrega = true;
                    }
                } else if (this.documento.documentType == 'INVOICE') {
                    if (/^([F][A-Z0-9]{3}|E001|[0-9]{1,4}|-)$/.test(x.serialNumber.toString())) {
                        seAgrega = true;
                    }
                }
                return seAgrega;

            });
            if (emisorConfig.length === 0) {
                swal({
                    title: 'Obligatorio',
                    text: 'Debe configurar al menos una serie para la nota de credito del emisor ',
                    type: 'warning',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 3000
                });
                setTimeout(() => {
                    const filtro: any = {};
                    filtro.busqueda = this.util.getCurrentUser().customer.ruc;
                    $('ul#slide-out').removeClass('open');
                    $('i.cerrarAleta').removeClass('open');
                    $('.closePopupNotaDebito').click();
                    this.router.navigate(['/content', {outlets: {'second': ['emisor', this.util.getCurrentUser().customer.id]}}]);
                }, 3000);
            } else {
                for (const ec of emisorConfig)
                    this.options.push(ec.serialNumber);
                if (this.options.length === 1) {
                    this.vld_serie.setValue(this.options[0]);
                }
            }
            this.loadingConsultas[0].cargando = false;
        }, err => {
            this.loadingConsultas[0].cargando = false;
            this.util.abrirModalErrorParaServicios(err, 'Error', this.router);
        });
    }

    pad(num: Number, size: number): string {
        let s = num + '';
        while (s.length < size) s = '0' + s;
        return s;
    }

    getDetalleFactura() {
        const body = {id: this.documento.id};
        this.loadingConsultas[1].cargando = true;
        this.consumerService.post(WebServices.URL_OBTENER_DETALLE, body).subscribe(result => {
            this.data = result['productsStocks'];
            this.receiver = result['receiver'];
            this.codCurrency = result['codCurrency'];
            const listCuo = result['paymentTerms'];
            if (listCuo != null && listCuo.length > 0) {
                this.payment.cuo = [];
                $.each(listCuo, (pos, item) => {
                    if (pos == 0) {
                        this.montoPendiente = item.amount;
                    }
                    if (pos > 0) {
                        this.payment.cuo.push(
                            {
                                idCuota: ((pos < 9) ? 'Cuota00' : 'Cuota0') + (pos + 1),
                                montoPago: item.amount,
                                fechaPago: item.paymentDueDate
                            });
                    }
                });
                if (this.payment.cuo.length > 0) {
                    this.tipos.push({value: '13', label: TipoNota.TIPO_13});
                    this.nroCuotas = this.payment.cuo.length;
                }
            }
            $.each(this.data, function (pos, item) {
                item.selected = false;
                item.invoicedQuantity = parseFloat(item.invoicedQuantity).toFixed(3);
                item.lineExtensionAmount = parseFloat(item.lineExtensionAmount).toFixed(2);
                item.unitPrice = parseFloat(item.unitPrice).toFixed(2);
            });
            this.datosBk = JSON.parse(JSON.stringify(result['productsStocks']));
            $.each(this.datosBk, function (pos, item) {
                item.selected = false;
                item.invoicedQuantity = parseFloat(item.invoicedQuantity).toFixed(3);
                item.lineExtensionAmount = parseFloat(item.lineExtensionAmount).toFixed(2);
                item.unitPrice = parseFloat(item.unitPrice).toFixed(2);
            });

            if (this.tipo.value == '04') {
                this.motivo = 'Descuento global';
            }

            this.loadingConsultas[1].cargando = false;
        }, err => {
            this.loadingConsultas[1].cargando = false;
            this.util.abrirModalErrorParaServicios(err, 'Error', this.router);
        });
    }

    seleccionarItem(datos, i) {
        this.datoBk = i;
        this.datosItemSelected = datos;

        if (this.tipo.value == '03' || this.tipo.value == '07') {
            if (this.tipo.value == '03') {
                this.overload_descripcion = true;
            } else if (this.tipo.value == '07') {
                this.overload_item = true;
            }
        }
    };

    ocultarOverload() {
        this.overload_item = false;
        this.overload_descripcion = false;
    }

    clickPrevent(event) {
        event.stopPropagation();
    }

    cancelarModificacion() {
        this.overload_item = false;
        this.overload_descripcion = false;
        this.datosItemSelected = this.datosBk[this.datoBk];
        this.datosItemSelected.selected = false;
    }

    volverOriginal() {
        this.overload_item = false;
        this.overload_descripcion = false;
        this.datosItemSelected.selected = false;
        this.datosItemSelected.invoicedQuantity = this.datosBk[this.datoBk].invoicedQuantity;
        this.datosItemSelected.lineExtensionAmount = this.datosBk[this.datoBk].lineExtensionAmount;
        this.datosItemSelected.unitPrice = this.datosBk[this.datoBk].unitPrice;
    }

    guardarModificacionDescripcion() {
        this.overload_descripcion = false;
        this.datosItemSelected.selected = true;
    }

    guardarModificacionItem() {
        this.overload_item = false;
        this.datosItemSelected.selected = true;
    }

    calcular() {
        this.datosItemSelected.invoicedQuantity = parseFloat(this.datosItemSelected.invoicedQuantity).toFixed(3);
        this.datosItemSelected.lineExtensionAmount =
            parseFloat(this.datosItemSelected.invoicedQuantity) *
            (this.datosItemSelected.unitPrice * (this.IGV / 100 + 1));


        this.datosItemSelected.lineExtensionAmount = parseFloat(this.datosItemSelected.lineExtensionAmount).toFixed(2);
    }

    verificarNumero() {
        if (this.datosItemSelected.invoicedQuantity != '' && this.datosItemSelected.invoicedQuantity != null) {
            try {
                const cantidad = parseFloat(this.datosItemSelected.invoicedQuantity);
            } catch (error) {
                this.datosItemSelected.invoicedQuantity = 1;
                return false;
            }
            if (this.datosItemSelected.invoicedQuantity == '' || this.datosItemSelected.invoicedQuantity == null || (parseFloat(this.datosItemSelected.invoicedQuantity) == parseFloat('0.000'))) {
                this.disabledGuardarModificacionItem = true;
                this.snackBar.open('La cantidad no puede ser 0 o vacia!.', null, {duration: 2000});
                return false;
            }


            if ((parseFloat(this.datosItemSelected.invoicedQuantity) < parseFloat('0')) ||
                (parseFloat(this.datosItemSelected.invoicedQuantity) > parseFloat(this.datosBk[this.datoBk].invoicedQuantity))) {
                this.disabledGuardarModificacionItem = true;
                this.snackBar.open('La cantidad ingresada no puede ser un valor negativo o mayor a "' + this.datosBk[this.datoBk].invoicedQuantity + '"', null, {duration: 2000});
                return false;
            }

            this.disabledGuardarModificacionItem = false;
        }
    }

    evitarCaracteresEspeciales(event) {
        if (event.which == 189 || event.which == 69)
            return false;
    }

    private _filter(value: string): String[] {
        const filterValue = value.toLowerCase();
        return this.options.filter(option => option.toLowerCase().includes(filterValue));
    }

    changeNroCuota(nro) {
        this.nroCuotas = nro;
        this.calcularCuota();
    }

    calcularCuota() {
        this.payment.cuo = [];
        for (let i = 0; i < this.nroCuotas; i++) {
            this.payment.cuo.push(
                {
                    idCuota: 'Cuota00' + (i + 1),
                    montoPago: this.getMontoCuota(),
                    fechaPago: this.generarFechaPago((i + 1))
                });
        }

        const aux = parseFloat(this.payment.cuo[this.payment.cuo.length - 1].montoPago) +
            (this.montoPendiente -
                (parseFloat(this.getMontoCuota()) * this.nroCuotas));

        this.payment.cuo[this.payment.cuo.length - 1].montoPago = aux.toFixed(2);
    }

    getMontoCuota() {
        return parseFloat((this.montoPendiente / this.nroCuotas).toString()).toFixed(2);
    }

    generarFechaPago(mes) {
        return moment().add(mes, 'M').format('YYYY-MM-DD');
    }

    seleccionarCuota(pos) {
        this.cuotaSelected = pos;
        this.changeAmountPay = this.payment.cuo[pos].montoPago;
        this.changeDate = this.payment.cuo[pos].fechaPago;
        if (pos === 0 && this.nroCuotas > 1) {
            this.minDate = moment().toDate();
            this.maxDate = moment().add(1, 'years').toDate();
        }
        if (pos === 0 && this.nroCuotas === 1) {
            this.minDate = moment().toDate();
            this.maxDate = moment().add(1, 'years').toDate();
        }

        if (pos !== 0 && pos < (this.payment.cuo.length - 1)) {
            this.minDate = moment(
                this.payment.cuo[pos - 1].fechaPago
            ).toDate();
            this.maxDate = moment(
                this.payment.cuo[pos + 1].fechaPago
            ).toDate();
        }

        if (pos !== 0 && pos === (this.payment.cuo.length - 1)) {
            this.minDate = moment(
                this.payment.cuo[pos - 1].fechaPago
            ).toDate();
            this.maxDate = moment().add(1, 'years').toDate();
        }
    }

    cambiar() {

        try {
            if (this.changeAmountPay == '' || this.changeAmountPay == null || parseFloat(this.changeAmountPay) == 0) {
                this.snackBar.open('El monto es un campo obligatorio', null, {duration: 2000});
                return false;
            }
        } catch (ex) {
            this.snackBar.open('El valor del monto no es numérico', null, {duration: 2000});
            return false;
        }
        if (moment(this.changeDate).format('YYYY-MM-DD') == 'Invalid date') {
            this.snackBar.open('La fecha debe tener un formato valido YYYY-MM-DD', null, {duration: 2000});
            return false;
        }


        if (!this.montoPermitido()) {
            this.snackBar.open('El monto supera lo permitido', null, {duration: 2000});
            this.changeAmountPay = parseFloat((this.payment.cuo[this.cuotaSelected].montoPago).toString()).toFixed(2);
            return false;
        }
        this.payment.cuo[this.cuotaSelected].montoPago = parseFloat((this.changeAmountPay).toString()).toFixed(2);
        this.payment.cuo[this.cuotaSelected].fechaPago =
            moment(this.changeDate).format('YYYY-MM-DD');
        this.cuotaSelected = null;
        this.changeAmountPay = null;
        this.changeDate = null;
    }

    montoPermitido() {
        const listEdit = this.payment.cuo.filter((item) => (item.edit));
        let listNotEdit;
        let totalEdit = 0;
        let cuotaNotEdit = 0;
        if (listEdit.length > 0) {
            listEdit.forEach(item => totalEdit = totalEdit + parseFloat(item.montoPago));
        }
        // SE PASA El CAMPO MODIFICADO A EDITADO
        this.payment.cuo[this.cuotaSelected].edit = true;

        // SE BUSCAN LOS QUE FALTAN POR SER MODIFICADOS
        listNotEdit = this.payment.cuo.filter((item) => (!item.edit));

        if (listNotEdit.length === 0) {
            this.changeAmountPay = parseFloat((this.montoPendiente - totalEdit).toString()).toFixed(2);
            return true;
        }

        if (parseFloat(this.changeAmountPay) >= this.montoPendiente) {
            return false;
        }

        if (parseFloat(this.changeAmountPay) + totalEdit >= (this.montoPendiente - listNotEdit.length)) {
            return false;
        }


        cuotaNotEdit = this.montoPendiente - (parseFloat(this.changeAmountPay) + totalEdit);
        cuotaNotEdit = parseFloat((cuotaNotEdit / listNotEdit.length).toFixed(2));
        listNotEdit.forEach(item => item.montoPago = cuotaNotEdit);

        return true;
    }

    cancelarChangeCuota() {
        this.cuotaSelected = null;
        this.changeAmountPay = null;
        this.changeDate = null;
    }

    generarPreview() {
        this.preview = true;
        debugger;
        this.dataPreview = [];
        if (this.tipo.value === '04') {
            this.dataPreview.push({
                'productCode': '----',
                'description': this.motivo === ''? 'DESCUENTO GLOBAL' : this.motivo,
                'invoicedQuantity': parseFloat("1").toFixed(3),
                'affectationIGV': 'GRAVADO',
                'lineExtensionAmount': parseFloat((this.monto * (this.IGV / 100 + 1)).toString()).toFixed(2),
                'unitPrice': parseFloat((this.monto).toString()).toFixed(2),
                'selected': false
            });
        } else if (this.tipo.value === '07') {
            this.dataPreview = this.data.filter(item => item.selected);
        } else {
            this.dataPreview = this.data;
        }
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/notaCredito/nota-credito.component.ts